import * as React from 'react';
import { getStoreState } from '../state/Store';

interface Props {
  imageUrl: string;
  background?: string;
}

export const OverlayIcon: React.FunctionComponent<Props> = props => {
  let background = props.background;
  if (!background) {
    const { isBeatflyerLite } = getStoreState().app;
    background = isBeatflyerLite
      ? 'var(--accent-color)'
      : 'linear-gradient(134.72deg, #FFE601 0%, #FF008C 101.5%)';
  }
  return (
    <div
      style={{
        display: 'inline-block'
      }}
    >
      <div
        className="img"
        style={{
          width: 48,
          height: 48,
          maskImage: `url('${props.imageUrl}')`,
          WebkitMaskImage: `url('${props.imageUrl}')`,
          background
        }}
      />
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/OverlayIcon.tsx